<template>
  <widget-step-page
    :btn-next-disabled="isBtnNextDisabled"
    :btn-prev-disabled="false"
    :on-btn-prev-clicked="onBtnPrevClicked"
    :on-btn-next-clicked="onBtnNextClicked"
  >
    <template #content>
      <div class="px-4 pb-14 pt-8">
        <div class="d-flex flex-column">
          <span
            v-if="currentFilialDoctorsList.length > 0 || otherFilialDoctorsList.length > 0"
            class="mb-4"
          >Выберите врача:</span>

          <!-- Врачи текущего филиала -->
          <template v-if="currentFilialDoctorsList.length > 0">
            <doctor-radio-group
              v-model="localDoctorFilialId"
              :doctor-list="currentFilialDoctorsList"
            />
          </template>
          <template v-else-if="otherFilialDoctorsList.length > 0">
            <span class="mb-3">В филиале, выбранном по умолчанию, в данный момент нет доступного времени для записи.</span>
          </template>

          <!-- Врачи других филиалов -->
          <template v-if="otherFilialDoctorsList.length > 0">
            <hr class="primary"/>
            <div class="d-flex justify-center align-center my-3" style="min-height: 16px">
              <v-icon size="14" color="primary">{{ icons.mdiMapMarker }}</v-icon>
              <span class="ml-1 x-font__primary primary--text">Другие филиалы</span>
            </div>
            <doctor-radio-group
              v-model="localDoctorFilialId"
              :doctor-list="otherFilialDoctorsList"
            />
          </template>

          <!-- Если нет никаких доступных времён -->
          <doctor-not-available-panel
            v-if="currentFilialDoctorsList.length === 0 && otherFilialDoctorsList.length === 0"
          />
        </div>
      </div>
    </template>
  </widget-step-page>
</template>

<script>
import {
  WIDGET_STEP__SELECT_FILIAL, WIDGET_STEP__SELECT_SERVICE,
  WIDGET_STEP__SELECT_SPEC_OR_DOCTOR
} from "@/plugins/consts"
import WidgetStepPage from "@/components/page-template/WidgetStepPage"
import {mdiMapMarker} from "@mdi/js"
import {isNullOrUndefined} from "@/plugins/object-helpers"
import DoctorRadioGroup from "@/components/pages/steps/select-doctor/DoctorRadioGroup"
import {mapGetters} from "vuex"
import DoctorNotAvailablePanel from "@/components/pages/steps/select-doctor/DoctorNotAvailablePanel.vue"

export default {
  components: {
    DoctorNotAvailablePanel,
    DoctorRadioGroup,
    WidgetStepPage
  },
  data() {
    return {
      icons: {
        mdiMapMarker,
      },

      localDoctorFilialId: null,
    }
  },
  mounted() {
    this.localDoctorFilialId = this.doctorFilialId
  },
  computed: {
    ...mapGetters([
      'defaultFilialId',
      'doctorId',
      'specialityName',
      'doctorFilialId',
      'currentFilialDoctorsList',
      'otherFilialDoctorsList',
    ]),
    isBtnNextDisabled() {
      return isNullOrUndefined(this.localDoctorFilialId)
    }
  },
  methods: {
    onBtnPrevClicked() {
      this.$store.commit('setDoctorFilialId', null)
      this.$store.commit('setDoctorId', null)
      this.$store.commit('setFilialDoctorsLists', [])
      this.$store.commit('setFilialSpecialitiesLists', [])
      this.$emit('change-step', WIDGET_STEP__SELECT_SPEC_OR_DOCTOR)
    },

    onBtnNextClicked() {
      if (this.isBtnNextDisabled) {
        return
      }

      if (!isNullOrUndefined(this.localDoctorFilialId)) {
        this.$store.commit('setDoctorFilialId', this.localDoctorFilialId)

        const allDoctors = [...this.currentFilialDoctorsList, ...this.otherFilialDoctorsList]
        const doc = allDoctors.find(it => it.id === this.localDoctorFilialId)
        if (doc === undefined) {
          return
        }
        this.$store.commit('setDoctorId', doc.doctorId)

        if (this.defaultFilialId !== null && this.defaultFilialId !== doc.filialId) {
          this.$store.commit('setFilialId', this.defaultFilialId)
        }
        this.$emit('change-step', WIDGET_STEP__SELECT_FILIAL)
      }
    },
  }
}
</script>

<style scoped>

</style>